import request from '@/utils/request'

// 字典项接口
export function getQryDictByCode (data) {
  return request({
    url: '/apis/sra/reg/users/signup/qryDictByCode', // 后端接口
    method: 'post',
    data
  })
}

// 查询区域接口
export function getQryByCode (data) {
  return request({
    url: '/apis/sra/reg/users/signup/qryJdAddress', // 后端接口
    method: 'post',
    data
  })
}

// 新增商家信息接口
export function getAddBusinessInfo (data) {
  return request({
    url: '/apis/sra/store/users/signup/addBusinessInfo', // 后端接口
    method: 'post',
    data
  })
}

// 商家基本信息查询接口
export function getQryBusinessInfo (data) {
  return request({
    url: '/apis/sra/store/users/signup/qryBusinessInfo', // 后端接口
    method: 'post',
    data
  })
}

// 天眼查查询商家信息接口
export function getQryBusinessInfoByTyc (data) {
  return request({
    url: '/apis/sra/store/users/signup/qryBusinessInfoByTyc', // 后端接口
    method: 'post',
    data
  })
}

// 查询商家联系人接口
export function getQryByBusName (data) {
  return request({
    url: '/apis/sra/store/users/signup/qryByBusName', // 后端接口
    method: 'post',
    data
  })
}
